// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36yod","importantInfo":"styles_importantInfo__34xzi"};